import { CountyCode, Partner, PartnerApi as PartnerApiClient } from 'pleinchamp-api-client';
import { ApiConfiguration, axiosInstance } from '@api/business/api.conf';
import Fuse from 'fuse.js';

export const PartnerApi = new PartnerApiClient(ApiConfiguration, undefined, axiosInstance);

export function filterPartners(partners?: Partner[], name?: string) {
  if (!partners) {
    return [];
  }
  if (!name || name.length === 0) {
    return partners;
  }
  const fuse = new Fuse(partners, { keys: ['name'], threshold: 0.2 });
  return fuse.search(name);
}

export async function getPartners(countyCodes?: CountyCode[]) {
  return PartnerApi.getPartners(countyCodes).then(r => r.data);
}
